import React from 'react'
import { useTranslation } from 'react-i18next'
import { SearchSelect } from '@/components/ui/search-select'
import { useBadgeCatalog } from './badgeCatalog'

/**
 * One badge of the community's catalog (owner and admin), searchable, with
 * its picture. `clearLabel` adds the empty choice ("Nenhum badge", "Qualquer
 * badge"); a saved badge that was removed from the catalog still shows by name.
 */
export const BadgePicker = ({ value, onChange, clearLabel, disabled, current, exclude, id, testId }: {
  value: string | null | undefined
  onChange: (badgeId: string) => void
  clearLabel?: string
  disabled?: boolean
  /** The saved badge, shown while the catalog loads or after it left the catalog. */
  current?: { id: string; name: string; imageUrl?: string } | null
  /** Ids not offered (the badges the person already holds). */
  exclude?: string[]
  id?: string
  testId?: string
}) => {
  const { t } = useTranslation('badges')
  const badges = useBadgeCatalog()
  const options = React.useMemo(() => {
    const rows = (badges ?? [])
      .filter((b) => !exclude?.includes(b.id) || b.id === value)
      .map((b) => ({
        value: b.id,
        label: b.name,
        image: b.imageUrl,
        description: b.visibility === 'private' ? t('picker.privateLine', { count: b.holders }) : t('picker.publicLine', { count: b.holders }),
        keywords: b.description ?? undefined
      }))
    if (current && !rows.some((r) => r.value === current.id)) rows.unshift({ value: current.id, label: current.name, image: current.imageUrl ?? '', description: '', keywords: undefined })
    return rows
  }, [badges, exclude, value, current, t])
  return (
    <SearchSelect
      id={id}
      testId={testId}
      value={value}
      onChange={onChange}
      options={options}
      loading={badges === null}
      disabled={disabled}
      clearLabel={clearLabel}
      placeholder={clearLabel ?? t('picker.placeholder')}
      searchPlaceholder={t('picker.search')}
      emptyLabel={badges && badges.length === 0 ? t('picker.emptyCatalog') : t('picker.nothing')}
    />
  )
}
